var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.checkbox,staticStyle:{"margin-left":"2rem"}},[_c('div',{staticStyle:{"display":"inline","position":"absolute","margin-left":"-2.5rem"}},[_vm._v(_vm._s(_vm.order)+".")]),_c('div',{style:({position: 'absolute',
        margin:'0 0 0 '+ _vm.boxMargin,
        display: _vm.inline,
        border: '1px solid #000!important',             
        width: '1em', 
        transform:'translate('+_vm.shift+'px,4px)',           
        height: '1em',           
        fontSize: '1.0em'})},[_c('div',{style:({transform:'translate('+_vm.shiftmark+'px,-4px)'}),domProps:{"innerHTML":_vm._s(_vm.getCheck())}})]),_c('div',{style:({display:'inline-block', margin:'0 0 0 1rem', textIndent: 0 }),domProps:{"innerHTML":_vm._s(_vm.text)}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }